import { BopsLogo } from '@Assets';

const MotifHalo = () => (
  <div className="relative w-[180px] h-[180px] flex items-center justify-center">
    {/* Breathing rings */}
    <div className="absolute inset-[30px] rounded-full border border-brand-500/35 animate-es-breathe opacity-90" />
    <div className="absolute inset-[10px] rounded-full border border-brand-500/25 animate-es-breathe-delayed opacity-55" />
    <div className="absolute -inset-[15px] rounded-full border border-brand-500/[0.18] animate-es-breathe-delayed-2 opacity-35" />

    {/* Center mark */}
    <div className="relative z-[2] w-[88px] h-[88px] rounded-full bg-white border border-gray-200 shadow-[0_0_28px_rgba(124,108,246,0.45),0_8px_24px_rgba(16,24,40,0.08)] flex items-center justify-center">
      <BopsLogo className="h-11" />
    </div>
  </div>
);

export default MotifHalo;
